export const ERROR_CODES = {
  UPLOAD_PARENT_NODE_ID_CAN_NOT_BE_EMPTY:
    'UPLOAD_PARENT_NODE_ID_CAN_NOT_BE_EMPTY',
  KC_ERROR_UPDATE_TOKEN: 'KC_ERROR_UPDATE_TOKEN',
  ERR_FILE_NOT_FOUND: 'ERR_FILE_NOT_FOUND',
} as const
